import areaApi from '@/api/config/areaApi'
import { queryKeys } from '@/constant/common'
import { AreaType } from '@/types/areaZone'
import { APIResponseList, SearchParams } from '@/types/common'
import { QueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

function useSearchArea(
  searchParams: SearchParams = {},
  interfaceId: number,
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<AreaType>, any> {
  return useQuery(
    [queryKeys.areaZone, interfaceId, searchParams],
    async () => {
      const { data } = await areaApi.getAll({
        ...searchParams,
        interfaceId,
      })

      if (!data) return null

      return {
        list: data.data,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
    queryOptions,
  )
}

export default useSearchArea
